import React, { useRef, useState, useEffect } from 'react';
import { Popup } from 'devextreme-react';
import Form, { SimpleItem, Label, StringLengthRule, RequiredRule } from 'devextreme-react/form';
import { Button } from 'devextreme-react/button';
import notify from 'devextreme/ui/notify';
import { useDispatch, useSelector } from 'react-redux'
import http from '../../utils/http';
import uri from '../../utils/uri';
import {  defaultGoal } from '../../data/defaultObjects';
import { editorOptionsSwitch, editorOptsTextBoxPhone, editorOptionsSelect, editorOptionsNumberBox, resources } from '../../data/app';
import { goalDialogAction } from '../../store/goal/goalDialogReducer'; 
import { createStoreLocal } from '../../utils/proxy';
import useAuthorization from '../../hooks/useAuthorization';

const Nuevo = (props) => {

    const { isMobile } = props;    

    //const [ _, canConfigureCredit ] = useAuthorization( resources.configurarCredito );

    const dispatch = useDispatch();
    
    const { goalDialog: { open, id  } } = useSelector(store => store);

    const [goal, setGoal] = useState({ ...defaultGoal }); 
    const [saving, setSaving] = useState({
        loading : false,
        text : 'Guardar'
    });

    const closeDialog = (load) => {
        dispatch(goalDialogAction({ id: 0, open: false }));
    
        if (load && props.onSave) 
            props.onSave();
        
    };

    const onHiding = ({ load }) => {

        closeDialog(load, 0);
        
    }

    const refForm = useRef();

    const guardar = (params) => {

        let result = refForm.current.instance.validate();      

        if (result.isValid) {

            setSaving({loading : true, text:'Guardando...'});
            
            http(uri.goals.insert).asPost(goal).then(resp => {

                notify('Datos guardados correctamente');
                setSaving({loading : false, text:'Guardar'});               
                closeDialog(true);
                refForm.current.instance.resetValues();

            }).catch(err => {

                setSaving({loading : false, text:'Guardar'});
                notify(err, 'error');

            });

        }
    }

    useEffect(() => {

        if(id > 0)
            http(uri.goals.getById(id)).asGet().then(resp => setGoal(cli => ({ ...resp })));
        else{
            setGoal({ ...defaultGoal });
            refForm.current.instance.resetValues();
        }
    }, [open]); 

    const updateGoal = (prop) => e => { 
        setGoal({ ...goal, [prop]: e.value });    
    }

    const propPop = isMobile ? { fullScreen: true } : { width: 400, height: 400 };

    return (
        <div>           
            <Popup
                title={`Metas`}
                {...propPop}
                onHiding={onHiding}
                visible={open}
                showCloseButton={true}
                className="bg-fbfbfb"
            >
                <Form formData={goal} ref={refForm} colCount={1}>                       
                    <SimpleItem dataField="description">
                        <Label text={'Descripción'} />
                        <StringLengthRule max={50} message="Maximo 50 caracteres" />
                    </SimpleItem>
                    <SimpleItem dataField="initDate" editorType='dxDateBox' editorOptions={{
                            openOnFieldClick:true
                        }}>
                        <Label text="Fecha inicio" />
                    </SimpleItem>   
                    <SimpleItem dataField="endDate" editorType='dxDateBox' editorOptions={{
                            openOnFieldClick:true
                        }}>
                        <Label text="Fecha fin" />
                    </SimpleItem>   
                    <SimpleItem dataField="active" editorType='dxSwitch' editorOptions={{...editorOptionsSwitch, onValueChanged: updateGoal('active')}}>
                        <Label text="Activo" />                        
                    </SimpleItem> 
                    
                </Form>
                <br />
                <Button
                    width={180}
                    text={saving.text} 
                    disabled={saving.loading}
                    type="default"
                    icon='save'
                    onClick={guardar}
                />
                <br />
            </Popup>
        </div>
    );
}

export default Nuevo;
